import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useColorModeValue,
  Link,
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { handleLogIn, storeAccountInfo } from '../services/account';
import GoogleLoginButton from '../components/GoogleLoginButton';
import Footer from '../components/layout/footer';

export default function SignInPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    let userData = {
      username: email,
      password: password,
    };

    try {
      let response = await handleLogIn(userData.username, userData.password);
      if (response.success === true) {
        let accInfoResponse = await storeAccountInfo();
        if (accInfoResponse?.success) {
          console.log('Acc info stored successfully');
        }
        window.location.href = '/home';
      }

      if (response.success === false) {
        const errorMessage =
          response.data?.response?.data?.detail ||
          'An error occured. Please check your network and try again.';
        setError(errorMessage);
      }
    } catch (error: any) {
      if (error.response) {
        const errorMessage =
          error.response.data.detail || 'Invalid credentials.';
        setError(errorMessage);
      } else if (error.request) {
        setError('Network error: Unable to reach the server.');
      } else {
        setError('Unexpected error occurred. Please try again.');
      }
      console.error('Error details:', error);
    }
  };

  return (
    <Flex
      mt={5}
      justify="center"
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <form onSubmit={handleSubmit}>
        <Box
          rounded="lg"
          bg={useColorModeValue('white', 'gray.700')}
          // boxShadow="lg"
          p={8}
          maxW="md"
          w="full"
        >
          <Stack spacing={4}>
            <Heading fontSize="2xl" textAlign="center" color="#009800ff">
              Sign in to your account
            </Heading>

            <Text fontSize="sm" textAlign="center" color="gray.500">
              Manage leads, handle follow-ups and close sales with ease.
            </Text>

            <Text fontSize="m" textAlign="center" color="red.500">
              {error}
            </Text>

            <FormControl id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />
            </FormControl>

            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                  placeholder="Enter your password"
                />
                <InputRightElement h="full">
                  <IconButton
                    variant="ghost"
                    aria-label="Toggle Password Visibility"
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </InputRightElement>
              </InputGroup>
            </FormControl>

            <Stack spacing={6} pt={4}>
              <Button
                size="lg"
                bg="#009800ff"
                color="white"
                type="submit"
                _hover={{ bg: '#009800ef' }}
              >
                Sign In
              </Button>

              <GoogleLoginButton />
            </Stack>

            <Stack pt={4}>
              <Text align="center">
                Don't have an account?{' '}
                <Link href="/sign-up" color="#009800ff">
                  Sign up
                </Link>
              </Text>
            </Stack>
          </Stack>
        </Box>
      </form>
      <Footer />
    </Flex>
  );
}
